export const authHeader = () => {
  const token = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : "";

  if (token) {
    return token;
  } else {
    return "";
  }
};
